var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createSmsCookie, } from '../SmsCookie';
import TwimlResponse from './TwimlResponse';
import { Exit, Message, Question, Reply, ActionSetMessageSid, ActionSetMessageSids, } from '../Actions';
const twilio = require('twilio');
export default class TwilioController {
    static isValidString(s) {
        return typeof s === 'string' && Boolean(s.length);
    }
    static typeCheckArguments(args) {
        Object.keys(args).map((option) => {
            if (!TwilioController.isValidString(args[option])) {
                throw new TypeError(`${option} twilly option must be a non-empty string`);
            }
        });
    }
    constructor({ accountSid, authToken, cookieKey, messagingServiceSid, sendOnExit, }) {
        TwilioController.typeCheckArguments({
            accountSid,
            authToken,
            cookieKey,
            messagingServiceSid,
            sendOnExit,
        });
        this.cookieKey = cookieKey;
        this.messagingServiceSid = messagingServiceSid;
        this.sendOnExit = sendOnExit;
        this.twilio = twilio(accountSid, authToken);
    }
    sendSmsMessage(to, body) {
        return __awaiter(this, void 0, void 0, function* () {
            if (Array.isArray(to)) {
                const data = yield Promise.all(to.map((dst) => this.twilio.messages.create({
                    body,
                    messagingServiceSid: this.messagingServiceSid,
                    to: dst,
                })));
                return data.map(m => m.sid);
            }
            const { sid } = yield this.twilio.messages.create({
                to: to,
                body,
                messagingServiceSid: this.messagingServiceSid,
            });
            return sid;
        });
    }
    clearSmsCookie(res) {
        res.clearCookie(this.cookieKey);
    }
    getSmsCookieFromRequest(req) {
        return req.cookies[this.cookieKey] || createSmsCookie(req);
    }
    handleAction(req, action) {
        return __awaiter(this, void 0, void 0, function* () {
            let sid;
            let sids;
            switch (action.constructor) {
                case Exit:
                    sid = (yield this.sendSmsMessage(req.body.From, this.sendOnExit));
                    action[ActionSetMessageSid](sid);
                    return;
                case Message:
                    sids = (yield this.sendSmsMessage(action.to, action.body));
                    action[ActionSetMessageSids](sids);
                    return;
                case Question:
                    yield (() => __awaiter(this, void 0, void 0, function* () {
                        const question = action;
                        sids = [];
                        if (question.isAnswered)
                            return;
                        if (question.isFailed) {
                            sids.push((yield this.sendSmsMessage(req.body.From, question.failedAnswerResponse)));
                            action[ActionSetMessageSids](sids);
                            return;
                        }
                        if (question.shouldSendInvalidRes) {
                            sids.push((yield this.sendSmsMessage(req.body.From, question.invalidAnswerResponse)));
                        }
                        sids.push((yield this.sendSmsMessage(req.body.From, question.body)));
                        action[ActionSetMessageSids](sids);
                    }))();
                    return;
                case Reply:
                    sid = (yield this.sendSmsMessage(req.body.From, action.body));
                    action[ActionSetMessageSid](sid);
                    return;
                default:
                    return;
            }
        });
    }
    sendEmptyResponse(res) {
        return new TwimlResponse(res).send();
    }
    sendMessageNotification(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.sendSmsMessage(msg.to, msg.body);
        });
    }
    sendSmsResponse(res, msg) {
        return new TwimlResponse(res).setMessage(msg).send();
    }
    setSmsCookie(res, payload) {
        res.cookie(this.cookieKey, payload);
    }
}
